export default {
  wrapper: {
    flexDirection: 'row'
  },
  text: {
    textAlign: 'left',
    marginLeft: '20px'
  }
};
